// src/dashboard/pages/teacher/Categories/components/CategoriesMembersMobileCards.jsx

import React from "react";
import { FaEdit } from "react-icons/fa";

import {
  formatDateFr,
  getMemberPhoto,
} from "../utils/categoriesDashboardUtils";

function WeightAction({ member, onUpdateWeight, updatingWeightId }) {
  const hasWeight = Number.isFinite(Number(member.poids)) && Number(member.poids) > 0;

  const handleClick = () => {
    const currentValue = hasWeight ? String(member.poids) : "";

    const value = window.prompt(
      `Nouveau poids pour ${(member.nom || "").toUpperCase()} ${
        member.prenom || ""
      } en kg :`,
      currentValue
    );

    if (value === null) return;

    onUpdateWeight?.(member, value);
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      disabled={updatingWeightId === member.id}
      className="mt-2 inline-flex w-full items-center justify-center gap-2 rounded-xl border border-slate-200 bg-white px-3 py-2 text-xs font-bold text-slate-700 transition hover:bg-slate-50 disabled:cursor-not-allowed disabled:opacity-50 dark:border-slate-700 dark:bg-slate-800 dark:text-slate-200"
    >
      <FaEdit />
      {hasWeight ? "Modifier le poids" : "Renseigner le poids"}
    </button>
  );
}

export default function CategoriesMembersMobileCards({
  members = [],
  onUpdateWeight,
  updatingWeightId,
}) {
  return (
    <div className="space-y-3 md:hidden">
      {members.map((member) => {
        const hasWeight =
          Number.isFinite(Number(member.poids)) && Number(member.poids) > 0;

        return (
          <article
            key={`mobile-${member.id}`}
            className="rounded-2xl border border-slate-200 bg-white p-4 shadow-sm dark:border-slate-800 dark:bg-slate-900/60"
          >
            <div className="flex gap-3">
              <img
                src={getMemberPhoto(member)}
                alt={`${member.prenom || ""} ${member.nom || ""}`}
                onError={(event) => {
                  event.currentTarget.src = "/img/user_avatar.jpg";
                }}
                className="h-16 w-16 rounded-2xl object-cover ring-1 ring-slate-200 dark:ring-slate-700"
              />

              <div className="min-w-0 flex-1">
                <h3 className="truncate text-sm font-bold text-slate-900 dark:text-white">
                  {(member.nom || "").toUpperCase()} {member.prenom || ""}
                </h3>

                <p className="mt-0.5 text-xs text-slate-500 dark:text-slate-400">
                  {member.genre || "—"} · Né(e) le{" "}
                  {formatDateFr(member.date_naissance)}
                </p>

                <p className="mt-0.5 text-xs text-slate-500 dark:text-slate-400">
                  {member.groupsLabel || "Aucun groupe"}
                </p>
              </div>
            </div>

            <div className="mt-4 grid grid-cols-2 gap-2">
              <div className="rounded-2xl bg-slate-50 p-3 dark:bg-slate-800/60">
                <p className="text-[11px] uppercase tracking-wide text-slate-500 dark:text-slate-400">
                  Catégorie
                </p>
                <p className="mt-1 text-sm font-bold text-slate-900 dark:text-white">
                  {member.ageLabel || "—"}
                </p>
              </div>

              <div className="rounded-2xl bg-slate-50 p-3 dark:bg-slate-800/60">
                <p className="text-[11px] uppercase tracking-wide text-slate-500 dark:text-slate-400">
                  Âge saison
                </p>
                <p className="mt-1 text-sm font-bold text-slate-900 dark:text-white">
                  {member.age !== null && member.age !== undefined
                    ? `${member.age} ans`
                    : "—"}
                </p>
              </div>

              <div className="rounded-2xl bg-slate-50 p-3 dark:bg-slate-800/60">
                <p className="text-[11px] uppercase tracking-wide text-slate-500 dark:text-slate-400">
                  Poids
                </p>

                {hasWeight ? (
                  <p className="mt-1 text-sm font-bold text-slate-900 dark:text-white">
                    {Number(member.poids)} kg
                  </p>
                ) : (
                  <p className="mt-1 text-sm font-bold text-rose-600 dark:text-rose-300">
                    À peser
                  </p>
                )}

                <WeightAction
                  member={member}
                  onUpdateWeight={onUpdateWeight}
                  updatingWeightId={updatingWeightId}
                />
              </div>

              <div className="rounded-2xl bg-slate-50 p-3 dark:bg-slate-800/60">
                <p className="text-[11px] uppercase tracking-wide text-slate-500 dark:text-slate-400">
                  Cat. poids
                </p>
                <p className="mt-1 text-sm font-bold text-slate-900 dark:text-white">
                  {member.weightBracket || "—"}
                </p>
              </div>
            </div>
          </article>
        );
      })}
    </div>
  );
}